<div *ngIf="!isHidden" class="rx-card">
    <div class="rx-card-title">
        <div class="rx-title-row" fxLayout="row" fxLayoutAlign="start center">
            <div class="treatment-information-title">{{ 'TreatmentInformation.TreatmentInformation' | translate }}</div>
        </div>
    </div>
    <div
        class="rx-card-body"
        *ngIf="
            isTreatmentsTableShownEmpty ||
            (treatments$ | async)?.length
        "
    >
        <table mat-table [dataSource]="treatments$" multiTemplateDataRows>
            <ng-container [matColumnDef]="'Tooth No'">
                <th mat-header-cell *matHeaderCellDef scope="col">
                    {{ 'TreatmentInformation.ToothNo' | translate }}
                </th>
                <td
                    mat-cell
                    *matCellDef="let tooth"
                    [class.invalid-for-send]="tooth.IsInvalidForSend"
                    [id]="'treatment-info-tooth-no-' + tooth.ToothID"
                >
                    <div>
                        {{ tooth.ToothID | mapper : getToothNumberById.bind(this) | async }}
                    </div>
                    <div class="invalid-for-send" *ngIf="tooth.IsInvalidForSend">
                        <p class="error-message">{{ 'TreatmentInformation.TreatmentErrorMessage' | translate }}</p>
                    </div>
                </td>
            </ng-container>
            <ng-container [matColumnDef]="'Treatment'">
                <th mat-header-cell *matHeaderCellDef scope="col">
                    {{ 'TreatmentInformation.Treatment' | translate }}
                </th>
                <td
                    [class.error-tr-field]="tooth.IsInvalidForSend"
                    mat-cell
                    *matCellDef="let tooth"
                    [id]="'treatment-info-treatment-' + tooth.ToothID"
                >
                    {{ tooth | mapper : getUnitType.bind(this) }}
                </td>
            </ng-container>
            <ng-container [matColumnDef]="'Specification'">
                <th id="treatment-info-specification-header" mat-header-cell *matHeaderCellDef scope="col">
                    {{ 'TreatmentInformation.Specification' | translate }}
                </th>
                <td
                    [class.error-tr-field]="tooth.IsInvalidForSend"
                    class="specification-cell"
                    mat-cell
                    *matCellDef="let tooth"
                    [id]="'treatment-info-specification-' + tooth.ToothID"
                >
                    {{  tooth.SpecificationId | mapper : getSpecificationName.bind(this) | async | emptyStringAsHyphen }}
                </td>
            </ng-container>
            <ng-container [matColumnDef]="'Material'">
                <th mat-header-cell *matHeaderCellDef scope="col">
                    {{ 'TreatmentInformation.Material' | translate }}
                </th>
                <td
                    [class.error-tr-field]="tooth.IsInvalidForSend"
                    class="material-cell"
                    mat-cell
                    *matCellDef="let tooth"
                    [id]="'treatment-info-material-' + tooth.ToothID"
                >
                    {{  tooth.MaterialID | mapper : getMaterialName.bind(this) | async | emptyStringAsHyphen }}
                </td>
            </ng-container>
            <ng-container [matColumnDef]="'Preparation design'" >
                <th mat-header-cell *matHeaderCellDef [hidden]="!isPrintContext">
                    {{ 'TreatmentInformation.PreparationDesign' | translate }}
                    <div>{{ 'Buccal/Lingual' | translate }}</div>
                </th>
                <td
                    [class.error-tr-field]="tooth.IsInvalidForSend"
                    [hidden]="!isPrintContext"
                    mat-cell
                    *matCellDef="let tooth"
                    [id]="'treatment-info-preparation-design-' + tooth.ToothID"
                >
                    {{ tooth.PreparationDesignBuccal | emptyStringAsHyphen | translate }}/{{
                        tooth.PreparationDesignLingual | emptyStringAsHyphen | translate
                    }}
                </td>
            </ng-container>
            <ng-container [matColumnDef]="'Shade'">
                <th mat-header-cell *matHeaderCellDef scope="col">
                    {{ ( isPrintContext ? 'TreatmentInformation.Shade' : 'TreatmentInformation.ShadeBody' ) | translate }}
                    <div *ngIf="isPrintContext">
                        {{ 'TreatmentInformation.Incisal' | translate }}/{{ 'TreatmentInformation.Body' | translate }}/{{
                            'TreatmentInformation.Gingival' | translate
                        }}
                    </div>
                </th>
                <td
                    [class.error-tr-field]="tooth.IsInvalidForSend"
                    mat-cell
                    *matCellDef="let tooth"
                    [id]="'treatment-info-shade-' + tooth.ToothID"
                >
                    {{ getShadeByTooth(tooth.ShadeIncisal, tooth.ShadeBody, tooth.ShadeGingival) }}
                </td>
            </ng-container>
            <ng-container [matColumnDef]="'Show details'">
                <th mat-header-cell *matHeaderCellDef></th>
                <td
                    [class.error-tr-field]="tooth.IsInvalidForSend"
                    mat-cell
                    *matCellDef="let tooth"
                    [id]="'treatment-info-show-details-' + tooth.ToothID"
                >
                    <a [ngClass]="{ link: true, disabled: !isTreatmentClickable(tooth) }" (click)="openToothEditor($event, tooth)">
                        {{ 'TreatmentInformation.ShowDetails' | translate }}</a
                    >
                </td>
            </ng-container>
            <ng-container [matColumnDef]="'Stump shade'">
                <th mat-header-cell *matHeaderCellDef scope="col">
                    {{ 'TreatmentInformation.StumpShade' | translate }}
                </th>
                <td [class.error-tr-field]="tooth.IsInvalidForSend" mat-cell *matCellDef="let tooth">
                    {{ tooth.StumpfShade | emptyStringAsHyphen }}
                </td>
            </ng-container>
            <ng-container matColumnDef="expandedDetailStart">
                <td [class.error-tr-field]="tooth.IsInvalidForSend" mat-cell *matCellDef="let tooth" colspan="1" [hidden]="!isPrintContext"></td>
            </ng-container>
            <ng-container matColumnDef="expandedDetailEnd">
                <td
                    [class.error-tr-field]="tooth.IsInvalidForSend"
                    mat-cell
                    *matCellDef="let tooth"
                    [attr.colspan]="displayedColumns.length - 1"
                    [hidden]="!isPrintContext"
                >
                    <div class="abutment-info">
                        <span>{{ 'TreatmentInformation.AbutmentType' | translate }}: </span>
                        <span class="text-muted">{{
                            tooth | mapper : getAbutmentTypeById.bind(this) | translate
                            }}</span
                        >{{ ' ; ' }}
                        <span>{{ 'TreatmentInformation.Material' | translate }}: </span>
                        <span class="text-muted"
                        >{{
                            (tooth.CAMaterialID || tooth.AbutmentMaterialId) | mapper : getMaterialName.bind(this) | async | emptyStringAsHyphen

                            }}{{ ' ; ' }}</span
                        >
                        <span>{{ 'TreatmentInformation.MarginStyle' | translate }}: </span>
                        <span class="text-muted">{{ tooth.AbutmentMarginStyle || tooth.CAMarginStyle | emptyStringAsHyphen }}</span>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="treatmentInfoDetailStart">
                <td mat-cell *matCellDef="let tooth" colspan="1"></td>
            </ng-container>
            <ng-container matColumnDef="treatmentInfoDetailEnd">
                <td mat-cell
                    *matCellDef="let tooth"
                    [attr.colspan]="displayedColumns.length - 1">
                    <rx-treatment-information-detail
                        [tooth]="tooth"
                        [material]="tooth.AbutmentMaterialId | mapper : getMaterialName.bind(this) | async"
                    ></rx-treatment-information-detail>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let tooth; columns: displayedColumns"
                [id]="'treatment-info-' + tooth.ToothID"
                [class.clickable-row]="tooth | mapper : isTreatmentClickable.bind(this)"
                (click)="openToothEditor($event, tooth)"
            ></tr>
            <tr
                mat-row
                *matRowDef="let tooth; columns: ['expandedDetailStart', 'expandedDetailEnd']"
                [id]="'expanded-info-details-' + tooth.ToothID"
                class="detail-row"
                [class.show-scan-body-info]="tooth | mapper : isAbutmentInfoAvailable.bind(this)"
                [class.clickable-row]="tooth | mapper : isTreatmentClickable.bind(this)"
                (click)="openToothEditor($event, tooth)"
            ></tr>
            <tr
                mat-row
                *matRowDef="let tooth; columns: ['treatmentInfoDetailStart', 'treatmentInfoDetailEnd']"
                [id]="'treatment-info-details-' + tooth.ToothID"
                class="detail-row"
                [class.show-scan-body-info]="isPrintContext"
            ></tr>
			<tr id="treatment-info-no-data" class="mat-row detail-row" *matNoDataRow
				[class.show-nodata]="(isPrintContext && hasNoBridge)">
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                	{{ 'TreatmentInformation.NoData' | translate }}
                </td>
            </tr>
        </table>
    </div>
    <div [formGroup]="ponticDesignGroupControls" class="bridges-container">
        <div class="rx-card bridge-container" *ngFor="let bridge of bridges$ | async">
            <div class="rx-card-title">
                <div class="rx-title-row" fxLayout="row" fxLayoutAlign="start center">
                    <div class="bridge-information-title" [id]="'treatment-info-bridge' + (bridge | mapper: getBridgeSpanId)">
                        {{ 'TreatmentInformation.Bridge' | translate }}
                        {{ bridge | mapper: getBridgeSpanTitle }}
                    </div>
                </div>
            </div>
            <div class="rx-card-body" [class.print-context]="isPrintContext">
                <table mat-table [dataSource]="bridge" multiTemplateDataRows>
                    <ng-container [matColumnDef]="'Tooth No'">
                        <th mat-header-cell *matHeaderCellDef scope="col">
                            {{ 'TreatmentInformation.ToothNo' | translate }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let tooth"
                            [class.invalid-for-send]="tooth.IsInvalidForSend"
                            [id]="'treatment-info-bridge-tooth-no' + (bridge | mapper: getBridgeSpanId) + '-' + tooth.ToothID"
                        >
                            <div>
                                {{ tooth.ToothID | mapper : getToothNumberById.bind(this) | async }}
                            </div>
                            <div class="invalid-for-send" *ngIf="tooth.IsInvalidForSend">
                                <p class="error-message">{{ 'TreatmentInformation.TreatmentErrorMessage' | translate }}</p>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container [matColumnDef]="'Treatment'">
                        <th mat-header-cell *matHeaderCellDef scope="col">
                            {{ 'TreatmentInformation.Treatment' | translate }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let tooth"
                            [id]="'treatment-info-bridge-treatment' + (bridge | mapper: getBridgeSpanId) + '-' + tooth.ToothID"
                        >
                            {{ tooth | mapper : getBridgeTreatment.bind(this) }}
                        </td>
                    </ng-container>
                    <ng-container [matColumnDef]="'Specification'">
                        <th id="treatment-info-bridge-specification-header" mat-header-cell *matHeaderCellDef scope="col">
                            {{ 'TreatmentInformation.Specification' | translate }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let tooth"
                            class="specification-cell"
                            [id]="'treatment-info-bridge-specification' + (bridge | mapper: getBridgeSpanId) + '-' + tooth.ToothID"
                        >
                            {{  tooth.SpecificationId | mapper : getSpecificationName.bind(this) | async | emptyStringAsHyphen }}
                        </td>
                    </ng-container>
                    <ng-container [matColumnDef]="'Material'">
                        <th mat-header-cell *matHeaderCellDef scope="col">
                            {{ 'TreatmentInformation.Material' | translate }}
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let tooth"
                            class="material-cell"
                            [id]="'treatment-info-bridge-material' + (bridge | mapper: getBridgeSpanId) + '-' + tooth.ToothID"
                        >
                            {{ tooth.MaterialID | mapper : getMaterialName.bind(this) | async | emptyStringAsHyphen }}
                        </td>
                    </ng-container>
                    <ng-container [matColumnDef]="'Shade'">
                        <th mat-header-cell *matHeaderCellDef scope="col">
                            {{ ( isPrintContext ? 'TreatmentInformation.Shade' : 'TreatmentInformation.ShadeBody' ) | translate }}
                            <div *ngIf="isPrintContext">
                                {{ 'TreatmentInformation.Incisal' | translate }}/{{ 'TreatmentInformation.Body' | translate }}/{{
                                    'TreatmentInformation.Gingival' | translate
                                }}
                            </div>
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let tooth"
                            [id]="'treatment-info-bridge-shade' + (bridge | mapper: getBridgeSpanId) + '-' + tooth.ToothID"
                        >
                            {{ getShadeByTooth(tooth.ShadeIncisal, tooth.ShadeBody, tooth.ShadeGingival) }}
                        </td>
                    </ng-container>
                    <ng-container [matColumnDef]="'Show details'">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td
                            mat-cell
                            *matCellDef="let tooth"
                            [id]="'treatment-info-bridge-show-details' + (bridge | mapper: getBridgeSpanId) + '-' + tooth.ToothID"
                        >
                            <a [ngClass]="{ link: true, disabled: !isTreatmentClickable(tooth) }" (click)="openToothEditor($event, tooth)">
                                {{ 'TreatmentInformation.ShowDetails' | translate }}</a
                            >
                        </td>
                    </ng-container>
                    <ng-container [matColumnDef]="'Stump shade'">
                        <th mat-header-cell *matHeaderCellDef scope="col">
                            {{ 'TreatmentInformation.StumpShade' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let tooth">
                            {{ tooth.StumpfShade | emptyStringAsHyphen }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="expandedDetailStart">
                        <td mat-cell *matCellDef="let tooth" colspan="1"></td>
                    </ng-container>
                    <ng-container matColumnDef="expandedDetailEnd">
                        <td mat-cell *matCellDef="let tooth" [attr.colspan]="displayedColumns.length - 1" [hidden]="!isPrintContext">
                            <div class="abutment-info">
                                <span>{{ 'TreatmentInformation.AbutmentType' | translate }}: </span>
                                <span class="text-muted">{{
                                    tooth | mapper : getAbutmentTypeById.bind(this) | translate
                                    }}</span
                                >{{ ' ; ' }}
                                <span>{{ 'TreatmentInformation.Material' | translate }}: </span>
                                <span class="text-muted"
                                >{{
                                    (tooth.CAMaterialID || tooth.AbutmentMaterialId) | mapper : getMaterialName.bind(this) | async | emptyStringAsHyphen

                                    }}{{ ' ; ' }}</span
                                >
                                <span>{{ 'TreatmentInformation.MarginStyle' | translate }}: </span>
                                <span class="text-muted">{{ tooth.AbutmentMarginStyle || tooth.CAMarginStyle | emptyStringAsHyphen }}</span>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="treatmentInfoDetailStart">
                        <td mat-cell *matCellDef="let tooth" colspan="1"></td>
                    </ng-container>
                    <ng-container matColumnDef="treatmentInfoDetailEnd">
                        <td mat-cell
                            *matCellDef="let tooth"
                            [attr.colspan]="displayedColumns.length - 1">
                            <rx-treatment-information-detail
                                [tooth]="tooth"
                                [material]="tooth.AbutmentMaterialId | mapper : getMaterialName.bind(this) | async"
                            ></rx-treatment-information-detail>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ponticLabel">
                        <td mat-cell  *matCellDef="let tooth" colspan="2">
                            <span>Pontic design</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pontic">
                        <td mat-cell  *matCellDef="let tooth" colspan="4">
                            <rx-pontic-selector
                                [formControl]="bridge | mapper : managePonticDesignControl.bind(this)"
                                [isReadonly]="true"
                                [options]="ponticDesigns"
                                [showLabel]="false"
                                name="pointicSelector"
                                class="pontic-size"
                            >
                            </rx-pontic-selector>
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let tooth; columns: displayedColumns"
                        [id]="'treatment-info-bridge-' + tooth.ToothID"
                        [class.clickable-row]="tooth | mapper : isTreatmentClickable.bind(this)"
                        (click)="openToothEditor($event, tooth)"
                    ></tr>
                    <tr
                        mat-row
                        *matRowDef="let tooth; columns: ['expandedDetailStart', 'expandedDetailEnd']"
                        [id]="'expanded-info-details-' + tooth.ToothID"
                        class="detail-row"
                        [class.show-scan-body-info]="tooth | mapper : isAbutmentInfoAvailable.bind(this)"
                        [class.clickable-row]="tooth | mapper : isTreatmentClickable.bind(this)"
                        (click)="openToothEditor($event, tooth)"
                    ></tr>
                    <tr
                        mat-row
                        *matRowDef="let tooth; columns: ['treatmentInfoDetailStart', 'treatmentInfoDetailEnd']"
                        [id]="'treatment-info-details-' + tooth.ToothID"
                        class="detail-row"
                        [class.show-scan-body-info]="isPrintContext"
                    ></tr>
                    <tr mat-row *matRowDef="let tooth; columns: ['ponticLabel','pontic']; when: (bridge | mapper : getFunctionForPonticRow.bind(this))" ></tr>
                </table>
            </div>
        </div>
    </div>
</div>
